import React, { useState } from 'react';
import { signInWithPopup } from "firebase/auth";
import { auth, provider } from "../firebase/firebase";
import { useNavigate } from 'react-router-dom';
import { FaGoogle } from 'react-icons/fa';
import './Login.css';

const ADMIN_EMAILS = ["angvictor91@gmail.com", "rekberidofficial@gmail.com"];
const WHITELISTED_UIDS = ['gZTDKq4Gg9aKtLRtvZU0TP7uQST2', 'lshstasFWvPDs51NwpfL2mJ84XC2'];

export default function Login() {
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async () => {
        try {
            setError('');
            setLoading(true);
            const result = await signInWithPopup(auth, provider);
            const { email, uid } = result.user;

            if (!ADMIN_EMAILS.includes(email) || !WHITELISTED_UIDS.includes(uid)) {
                await auth.signOut();
                setError('Access Denied: Not authorized.');
                return;
            }

            navigate('/');
        } catch (error) {
            console.error('Login error:', error);
            setError('Failed to sign in. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <h1>Rekber Admin</h1>
                    <p>Secure transaction management platform</p>
                </div>

                <div className="login-content">
                    <button
                        onClick={handleLogin}
                        disabled={loading}
                        className="google-login-btn"
                    >
                        <FaGoogle className="google-icon" />
                        <span>{loading ? 'Signing in...' : 'Sign in with Google'}</span>
                    </button>

                    {error && (
                        <div className="error-message">
                            {error}
                        </div>
                    )}
                </div>

                <div className="login-footer">
                    <p>Protected Admin Dashboard</p>
                    <small>© {new Date().getFullYear()} PT REKBER SECURE INDONESIA. All rights reserved.</small>
                </div>
            </div>
        </div>
    );
}